import { createContext, useContext } from "react";
import { useProperties } from "@/hooks/useProperties";

const PropertyContext = createContext(undefined);

export const PropertyProvider = ({ children }) => {
    const propertiesData = useProperties();

    return (
        <PropertyContext.Provider value={propertiesData}>
            {children}
        </PropertyContext.Provider>
    );
};

export const usePropertyContext = () => {
    const context = useContext(PropertyContext);
    // Graceful fallback to avoid app crash if context is missing during initialization
    return context || { properties: [], loading: true, activeProperty: null };
};

// Also export useProperty as alias if needed by older code, though clearly usePropertyContext is the standard now.
export const useProperty = usePropertyContext;
